import React, { FC } from 'react';
import { ArrowRightOutlined } from '@ant-design/icons';
import LockIcon from '../icons/LockIcon';

interface ClientsProUpsellPanelProps {
	// Name of the gated feature, shown in the heading (e.g. "Clients").
	feature?: string;
}

// Inline upsell rendered in place of a Supplier-Pro-only Clients tab (All / All
// Locations) when the supplier isn't on Supplier Pro. The tab stays clickable; only
// its body is replaced. Compliance is free and never renders this.
const ClientsProUpsellPanel: FC<ClientsProUpsellPanelProps> = ({
	feature = 'This',
}): React.ReactElement => {
	const handleContactSupport = () => {
		if ((window as any).Intercom) {
			(window as any).Intercom('startConversation', 'Interested in Supplier pro');
		}
	};

	return (
		<div className="flex w-full flex-col items-center justify-center gap-3 rounded-md bg-white px-6 py-16 text-center">
			<span className="footnoteregular inline-flex items-center gap-[3px] rounded-[100px] bg-teal-2 px-2 py-[2px] capitalize text-white">
				<LockIcon />
				<span>Pro</span>
			</span>
			<h4 className="h4medium text-character-primary">{feature} is a Supplier Pro feature</h4>
			<span className="bodyregular max-w-md text-character-secondary">
				Upgrade to Supplier Pro to manage your clients and their locations. Compliance is available
				on any plan.
			</span>
			<button
				type="button"
				onClick={handleContactSupport}
				className="bodymedium mt-1 inline-flex w-fit cursor-pointer items-center gap-2xs border-0 bg-transparent p-0 text-cyan-7 underline"
			>
				<span>Contact Support to Upgrade</span>
				<ArrowRightOutlined className="text-[15px]" />
			</button>
		</div>
	);
};

export default ClientsProUpsellPanel;
